"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetrieveDriversCompaniesOptions = void 0;
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const RetrieveUsersOptions_1 = require("./RetrieveUsersOptions");
let RetrieveDriversCompaniesOptions = class RetrieveDriversCompaniesOptions extends RetrieveUsersOptions_1.RetrieveUsersOptions {
};
exports.RetrieveDriversCompaniesOptions = RetrieveDriversCompaniesOptions;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], RetrieveDriversCompaniesOptions.prototype, "ids", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => Number(item)))),
    __metadata("design:type", Array)
], RetrieveDriversCompaniesOptions.prototype, "statusIn", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value.map((item) => String(item)))),
    __metadata("design:type", Array)
], RetrieveDriversCompaniesOptions.prototype, "managerIds", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], RetrieveDriversCompaniesOptions.prototype, "payoutType", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => value && value.map((item) => String(item))),
    __metadata("design:type", Array)
], RetrieveDriversCompaniesOptions.prototype, "vehicleModelIds", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveDriversCompaniesOptions.prototype, "isActiveInLast7Days", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveDriversCompaniesOptions.prototype, "isWillingToRentEnabled", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], RetrieveDriversCompaniesOptions.prototype, "hasPendingDocuments", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], RetrieveDriversCompaniesOptions.prototype, "excludeDocumentTypeIds", void 0);
exports.RetrieveDriversCompaniesOptions = RetrieveDriversCompaniesOptions = __decorate([
    (0, class_transformer_1.Exclude)()
], RetrieveDriversCompaniesOptions);
//# sourceMappingURL=RetrieveDriversCompaniesOptions.js.map